import { gql } from '@apollo/client';

import { RankingStudent, RankingItem } from '../../types';
import { rankingStudentFragment, rankingItemFragment } from '../fragments';

export interface GetSubjectsRankingQueryVariables {
  courseId: string;
  queryParams: {
    startDate: string;
    endDate: string;
  };
}

export interface GetSubjectsRankingQueryResult {
  subjectsRankingPayload: {
    courseId: string;
    courseName: string;
    students: RankingStudent[];
    subjects: RankingItem[];
  };
}

export const getSubjectsRankingQuery = gql`
  query GetSubjectsRankingQuery($courseId: String!, $queryParams: QueryParamsVariables!) {
    subjectsRankingPayload(courseId: $courseId, queryParams: $queryParams)
      @rest(
        type: "SubjectsRankingPayload"
        path: "courses/{args.courseId}/leaderboard/subjects?startDate={args.queryParams.startDate}&endDate={args.queryParams.endDate}"
      ) {
      courseId
      courseName
      students @type(name: "RankingStudent") {
        ...RankingStudent
      }
      subjects @type(name: "RankingItem") {
        ...RankingItem
      }
    }
  }
  ${rankingStudentFragment}
  ${rankingItemFragment}
`;
